import Attribute from "vueforms/src/xmlrdb-metadata/Attribute"

/**
 * 
 * @param {import("vueforms/src/xmlrdb-data/Attribute").default} attr 
 * @returns 
 */
Attribute.ValidatorFunctionRegistry["MA.AUSGABENLISTE.KOSTENKATisSet"] = function KOSTENKATisSet(attr) {
  let hasKostenKategorie = attr.dataElement.root().subElements["ERKL_KOSTENKATEGORIE"].dataElements.length > 1;
  if (attr.value === null && hasKostenKategorie) {
    return "Sie müssen eine Kostenkategorie angeben.";
  }
}

/**
 * 
 * @param {import("vueforms/src/xmlrdb-data/Attribute").default} attr 
 * @returns 
 */
 Attribute.ValidatorFunctionRegistry["MA.AUSGABENLISTE.AUSGABENKATisSet"] = function AUSGABENKATisSet(attr) {
  let hasAusgabenKategorie = attr.dataElement.root().subElements["ERKL_AUSGABENKATEGORIE"].dataElements.length > 1;
  if( attr.value === null && hasAusgabenKategorie)
    return "Sie müssen eine Ausgabenkategorie angeben.";
}